<template>
<div class="equipments">

	<!-- page-heading -->
	<page-heading :show="true" pageTitle="EQUIPMENTS-HEADER"></page-heading>

	<div class="columns">

		<div class="col-main">

			<!-- show loading indicator -->
			<loading-indicator :loading="isLoading"></loading-indicator>

			<template v-if="!isLoading">

				<v-client-table ref="tblEquipments" name="tblEquipments" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tbl-equipments noFirstColumn">

					<!-- before table: FILTER OPTIONS -->
	                <template slot="beforeTable">

						<!-- SEARCH -->
						<div class="control has-icon search is-pulled-left">
							<input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
							<i class="fa fa-search" aria-hidden="true"></i>
						</div>

						<div class="is-pulled-right">
							<div class="columns is-marginless filters">

								<div class="column is-narrow">
									<div class="control is-horizontal is-pulled-right">
										<div class="control-label">
											<label-name labelKey="ECE-FILTER-SHOW_EQUIPMENTS_MORE_THAN_ONE_CATEGORY"></label-name>
										</div>
										<div style="padding-top: 7px">
											<b-switch v-model.sync="showEquipmentsWithMoreThanOneCategory" type="primary" class="is-small"></b-switch>
										</div>
									</div>
								</div>

	                    	</div>

						</div>

	                </template>

					<!-- image -->
					<template slot="asset" slot-scope="props">
						<div class="imgWrapper lazy-img-fadein" v-lazy:background-image="equipmentImageGet(props.row.asset)" :key="props.row.id"></div>
					</template>

					<!-- categories -->
					<template slot="category" slot-scope="props">
						<ul v-if="props.row.categories.length > 0">
							<li v-for="category in props.row.categories" v-if="category!=null" style="white-space: normal;">
								<router-link :to="{ name: 'equipmentCatalogPage', params: { 'equipmentCatalogPageID': category.pageId }}" class="page">{{ category.name }}</router-link>
							</li>
						</ul>
					</template>

					<!-- online Category -->
					<template slot="onlineCategory" slot-scope="props">
						<span style="white-space: normal;">{{ props.row.onlineCategory }}</span>
					</template>

					<!-- delete -->
					<template slot="delete" slot-scope="props">
						<span class="del icon is-small" @click="equipmentDelete(props.row.id)">
							<i class="icon-ak-entfernen"></i>
						</span>
					</template>

				</v-client-table>

			</template>

		</div>


		<div class="col-aside">

			<affix :offset="50">

				<div class="sidebox">
					<custom-button type="blue" name="EQUIPMENTS-BTN-EQUIPMENT_ADD" icon="icon-ak-hinzufuegen" @click.native="newEquipment"></custom-button>
				</div>

				<div class="sidebox">
					<template v-if="!isLoading">
						<small>{{ stats.equipmentsTotal }} Geräte gesamt</small><br />
						<small>{{ equipmentsOnline }} Geräte im Online-Katalog</small>
					</template>
				</div>



				<export-button export="equipments" btnTitle="EQUIPMENTS-BTN-EXPORT" modalTitle="EQUIPMENTS-MODAL_HEADER-EXPORT_EQUIPMENTS"></export-button>

				<!-- IMPORT  -->
				<upload-box
					type="button"
					:url= "$config.api + 'fileProcessing/upload?preset=importEquipmentFuturePrices'"
					:thumbnailWidth="145"
					:thumbnailHeight="67"
					:showIcon="true"
					iconClass="fa fa-cloud-upload"
					acceptedFiles=".xls,.xlsx"
					label="Zukunftspreise">
				</upload-box>


			</affix>

		</div>

	</div>


</div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

import exportButton from '../utils/exportButton';
import uploadBox from '../utils/uploadBox';

export default {

	name: 'equipments',

	components: {
		exportButton,
		uploadBox
	},

	data() {

		var self = this;

		return {
			isLoading: false,
			stats: {
				equipmentsTotal: '',
			},

			showEquipmentsWithMoreThanOneCategory: false,
			equipmentCategories: [],

			table: {

				tblColumns: ['asset', 'extRef', 'name', 'piecesPerPackage', 'priceAEP', 'category', 'onlineCategory', 'delete'],

				tblData: [],

				tblOptions: {
					trackBy: 'id',
                    uniqueKey: 'id',
					saveState: true,
					perPage: 25,
					orderBy: {
						ascending: true,
						column: 'name'
					},

                    // custom table headings - make them clickable for language Setting
					headings: {

						asset: function(h) {
							return <lang labelKey="EQUIPMENTS_TBL_HEADER-IMAGE"></lang>
						},
						extRef: function(h) {
							return <lang labelKey="EQUIPMENTS_TBL_HEADER-EXTREF"></lang>
						},
						name: function(h) {
							return <lang labelKey="EQUIPMENTS_TBL_HEADER-NAME"></lang>
						},
						piecesPerPackage: function(h) {
							return <lang labelKey="EQUIPMENTS_TBL_HEADER-PIECES_PER_PACKAGE"></lang>
						},
						priceAEP: function(h) {
							return <lang labelKey="EQUIPMENTS_TBL_HEADER-PRICE"></lang>
						},
						category: function(h) {
							return <lang labelKey="EQUIPMENTS_TBL_HEADER-CATEGORY"></lang>
						},
						onlineCategory: function(h) {
							return <lang labelKey="EQUIPMENTS_TBL_HEADER-ONLINE_CATEGORY"></lang>
						},
						delete: function(h) {
                            return <lang labelKey="EQUIPMENTS_TBL_HEADER-DELETE"></lang>
                        },
					},

					sortable: ['name', 'extRef'],
					sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

					filterByColumn: false,
					filterable: false,

					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'keine passenden Einträge gefunden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},

					pagination: {
						chunk: 5
					},

					skin: 'table is-striped is-hoverable is-fullwidth',

					templates: {

						priceAEP(h, row) {
							// return self.formatPoint2Comma(row.priceAEP, 2);
							return row.priceAEP;
						},

					},

					initFilters: {
                        search: self.$store.getters.getEquipmentsFilter('searchString'),
                    },

					// custom filter functions
					customFilters: [
						{
							name: 'search',
							callback(row, string) {

								if(string == null || string == "") {
									return true;
								}

								string = string.toLowerCase();

								if(row.extRef == null) {
									// console.log(row.name);
								}

								return row.name && row.name != null && row.name != "" && row.name.toLowerCase().indexOf(string) > -1 || row.extRef != null && row.extRef.indexOf(string) > -1;

							}
						},
						{
							name: 'showMoreThanOneCategory',
							callback(row, val) {

								if(val === true) {

									if(row.categories.length > 1) {

										let counter = 0;

										for(let i=0; i < row.categories.length; i++) {
											if(row.categories[i].category != null) {
												counter++
											}
										}

										return counter > 1;

									}

								} else {

									return;

								}


							}
						}
					],

				}
			}

		}
	},

	computed: {

		searchString: {

            get() {
                return this.$store.getters.getEquipmentsFilter('searchString');
            },

            set(val) {

                // save new values in our store
                this.$store.commit('setEquipmentsFilter', { type: 'searchString', value: val });

                // emit new values to our table component
                Event.$emit('vue-tables.tblEquipments.filter::search', val);

            }

        },

		equipmentsOnline() {

			var count = 0;
			this.table.tblData.forEach((eq) => {

				if(eq.onlineCategory != null) {
					count++;
				}

			})

			return count;

		}
	},

	watch: {
		/*
		searchString(val) {
			Event.$emit('vue-tables.tblEquipments.filter::search', val);
		},
		*/

		showEquipmentsWithMoreThanOneCategory(val) {
			Event.$emit('vue-tables.tblEquipments.filter::showMoreThanOneCategory', val);
		}

	},

	created() {

		this.fetchData();

	},

	mounted() {

		Event.$on('vue-tables.tblEquipments.row-click', function (data) {

			if(['icon-ak-entfernen', 'page'].indexOf(data.event.target.className) > -1) {
				return false;
			}

			this.$router.push({ name: 'equipment', params: { 'equipmentID': data.row.id }  });
		}.bind(this));

	},


	methods: {

		equipmentDelete(id) {

			// find the index of the clicked row first
			var foundIndex = "";
			this.table.tblData.forEach(function(row, index) {
				if(row.id == id) {
					foundIndex = index;
				}
			})

			// if we found an index, delete the category in the DB
			// and remove it from the array
			if(foundIndex != "") {

				var self = this;
				this.entityDelete('equipment', this.table.tblData[foundIndex].id, 'EQUIPMENTS-MSG-CONFIRM_DELETION')
					.then(function(response) {
						self.table.tblData.splice(foundIndex, 1);
					})

			}


		},

		equipmentImageGet(asset) {

			if(asset != null) {
				return this.$config.assets + asset.path + '/thumb/' + asset.filename;
			}

			return "";

		},

		newEquipment() {

			this.$router.push({ name: 'equipmentNew' });

	    },

		/*
		search() {

			var self = this;

            setTimeout(function() {
                Event.$emit('vue-tables.tblEquipments.filter::search', self.searchString);
            }, 10);

		},
		*/

		fetchData() {

			this.isLoading = true;
			var self = this;

			function getEquipmentCategories() {
				return self.axios.get(self.$config.api + 'equipmentCategory');
			}

			// get equipments
			function getEquipments() {
				// return self.axios.get(self.$config.api + 'equipment?include=equipment.categories,equipmentCategory.pages,equipmentCategoryEquipment.category,equipment.asset,equipment.onlineCategory');
				return self.axios.get(self.$config.api + 'equipment/liteList');
			}

			// make the request
			this.axios.all([getEquipments(), getEquipmentCategories()])

				.then(self.axios.spread(function (equipments, equipmentCats) {

					self.table.tblData = equipments.data;
					self.stats.equipmentsTotal = equipments.data.length;
					self.equipmentCategories = equipmentCats.data.equipmentCategory;
					// self.table.tblData = equipments.data.equipment;
					// self.stats.equipmentsTotal = equipments.data.equipment.length;

					self.isLoading = false;

				})).catch(function(error) {
					self.isLoading = false;
					console.log('Error: ', error.message);
				});
		},

	}

}
</script>

<style lang="scss">

    // @import '../../assets/css/variables.scss';

		/* equipments table */
		.tbl-equipments {

			table {
				table-layout: fixed;
				overflow: unset !important;

				thead {
					position: sticky;
					top: 0;
					z-index: 999999;
					background: #FFF;
					box-shadow: 0 1px 1px -1px rgb(0 0 0 / 40%);

					th {
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						max-width: 500px;
					}

				}




			}

		}

</style>

<style>


	.tbl-equipments table th:first-child,
	.tbl-equipments table th:nth-child(2) {
		width: 120px;
	}

	.tbl-equipments table th:nth-child(4),
	.tbl-equipments table th:nth-child(5) {
		width: 85px;
	}

	.tbl-equipments table th:last-child,
	.tbl-equipments table td:last-child {
		width: 90px;
		text-align: center;
	}

	.tbl-equipments .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: 60%;
		width: 100px;
		height: 80px;
		margin: 0;
		background-color: #FFF;
		border: 1px solid #efefef;
		border-radius: 2px;
	}
	.tbl-equipments .imgWrapper[lazy=loading]  {
		background-size: 30% !important;
	}

</style>
